import React, { useState, useEffect } from 'react';
import './Testimonials.css';

const testimonialData = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "Marketing Manager",
    company: "TechCorp",
    photo: "./client1.jpg",
    quote: "This product has completely transformed our workflow and increased our productivity!"
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Product Designer",
    company: "InnovateX",
    photo: "./client2.jpg",
    quote: "Incredibly intuitive design and amazing customer support. Highly recommended!"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    role: "Startup Founder",
    company: "GrowthHub",
    photo: "./client3.jpg",
    quote: "A game-changing solution that solved our most critical business challenges."
  },
  {
    id: 4,
    name: "David Kim",
    role: "IT Director",
    company: "GlobalSolutions",
    photo: "./client4.jpg",
    quote: "Seamless integration and exceptional performance. It's like they read our minds!"
  }
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(3);

  useEffect(() => {
    // Handle responsive slides
    const handleResize = () => {
      if (window.innerWidth <= 600) setSlidesToShow(1);
      else if (window.innerWidth <= 992) setSlidesToShow(2);
      else setSlidesToShow(3);
    };
    window.addEventListener('resize', handleResize);
    handleResize(); // initial check
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // Auto-slide
    const slideInterval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const maxIndex = testimonialData.length - slidesToShow;
        if (prevIndex >= maxIndex) return 0; // reset to start
        return prevIndex + 1; // move one card forward
      });
    }, 5000);
    return () => clearInterval(slideInterval);
  }, [slidesToShow]);

  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <h2 className="testimonials-title">What Our Clients Say</h2>
        {/* <div className="testimonial-slider-wrapper">
          <div
            className="testimonial-slider"
            style={{
              width: `${(testimonialData.length / slidesToShow) * 100}%`,
              transform: `translateX(-${(currentIndex * 100) / testimonialData.length}%)`
            }}
          >
            {testimonialData.map((testimonial) => (
              <div
                key={testimonial.id}
                className="testimonial-card"
                style={{ width: `${100 / testimonialData.length}%` }}
              >
                <div className="testimonial-content">
                  <img
                    src={testimonial.photo}
                    alt={testimonial.name}
                    className="testimonial-photo"
                  />
                  <p className="testimonial-quote">
                    "{testimonial.quote.length > 40
                      ? testimonial.quote.slice(0, 40) + '...'
                      : testimonial.quote}"
                  </p>
                  <div className="testimonial-info">
                    <h3 className="testimonial-name">{testimonial.name}</h3>
                    <p className="testimonial-role">
                      {testimonial.role} at {testimonial.company}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div> */}
        <div className="testimonial-slider-wrapper">
          <div
            className="testimonial-slider"
            style={{
              width: `${(testimonialData.length * 100) / slidesToShow}%`,
              transform: `translateX(-${(currentIndex * 100) / testimonialData.length}%)`
            }}
          >
            {testimonialData.map((testimonial) => (
              <div
                key={testimonial.id}
                className="testimonial-card"
                style={{ width: `${100 / slidesToShow}%` }}
              >
                <div className="testimonial-content">
                  <img
                    src={testimonial.photo}
                    alt={testimonial.name}
                    className="testimonial-photo"
                  />
                  <p className="testimonial-quote">
                    "{testimonial.quote.length > 40
                      ? testimonial.quote.slice(0, 40) + '...'
                      : testimonial.quote}"
                  </p>
                  <div className="testimonial-info">
                    <h3 className="testimonial-name">{testimonial.name}</h3>
                    <p className="testimonial-role">
                      {testimonial.role} at {testimonial.company}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="testimonial-dots">
          {Array.from({ length: testimonialData.length - slidesToShow + 1 }).map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>

      </div>
    </section>
  );
};

export default Testimonials;
